// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip__tooltip___BFk0F","top":"tooltip__top___r5nIo"};